import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "controls" }
const _hoisted_2 = { class: "controls__search form-control-input-wrapper-redesigned" }
const _hoisted_3 = { class: "controls__events" }
const _hoisted_4 = { class: "controls__events-top" }
const _hoisted_5 = { class: "controls__events-group" }
const _hoisted_6 = { class: "controls__events-group" }
const _hoisted_7 = { class: "controls__events-bottom" }
const _hoisted_8 = { ref: "globalContextMenuButtonWrapper" }
const _hoisted_9 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_10 = ["data-index", "data-key"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "list__item-checkbox" }
const _hoisted_14 = { class: "checkboxInput" }
const _hoisted_15 = ["checked", "disabled", "value", "id", "onClick"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "list__visually-hidden" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "list__item-folder fas fa-folder"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 2,
  class: "tr_not-found"
}
const _hoisted_23 = { class: "modal__body-footer-redesigned" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_GlobalContextMenu = _resolveComponent("GlobalContextMenu")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_LocalContextMenu = _resolveComponent("LocalContextMenu")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    modelValue: _ctx.catalogModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.catalogModal) = $event)),
    width: 848,
    height: "100%",
    title: "Выбор товара",
    onClose: _ctx.closeCatalog
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.term) = $event)),
            placeholder: "Поиск",
            class: "form-control",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, null, 544), [
            [_vModelText, _ctx.request.term]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.multiple)
                ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                    key: 0,
                    mod: "only-blue-text",
                    class: "controls__button",
                    onClick: _ctx.selectAllItems,
                    disabled: _ctx.isLoading
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" Выбрать все ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.multiple)
                ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                    key: 1,
                    mod: "only-blue-text",
                    class: "controls__button",
                    onClick: _ctx.unselectAllItems,
                    disabled: _ctx.isLoading
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Снять все ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ButtonComponent, {
                mod: "only-blue-text",
                class: "controls__button",
                onClick: _ctx.openAllItems,
                disabled: _ctx.isLoading
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Развернуть все ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_ButtonComponent, {
                mod: "only-blue-text",
                class: "controls__button",
                onClick: _ctx.closeAllItems,
                disabled: _ctx.isLoading
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" Свернуть все ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.multiple)
                ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                    key: 0,
                    mod: "only-blue-text",
                    class: "controls__button controls__button_level",
                    onClick: _withModifiers(_ctx.openGlobalContextMenu, ["stop"]),
                    disabled: _ctx.isLoading
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" Выбрать уровень ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.multiple)
                ? (_openBlock(), _createBlock(_component_GlobalContextMenu, {
                    key: 1,
                    isVisible: _ctx.globalContextMenu.isVisible,
                    position: _ctx.globalContextMenu.position,
                    onAction: _ctx.selectLevel,
                    onClose: _ctx.closeGlobalContextMenu,
                    onSelectProductsGroups: _ctx.selectProductsGroups
                  }, null, 8, ["isVisible", "position", "onAction", "onClose", "onSelectProductsGroups"]))
                : _createCommentVNode("", true)
            ], 512)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["list-container", { 'list-container_loading': _ctx.isLoading }]),
        ref: "listContainer"
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_Loader)
            ]))
          : _createCommentVNode("", true),
        (_ctx.getVisibleItems.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "list-wrapper",
              style: _normalizeStyle(_ctx.getListWrapperStyle)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVirtualRows, (virtualRow) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list",
                  key: String(virtualRow.key),
                  ref_for: true,
                  ref: _ctx.measureElement,
                  "data-index": virtualRow.index,
                  "data-key": _ctx.getItemKey(_ctx.getVisibleItems[virtualRow.index]),
                  style: _normalizeStyle(_ctx.getListStyle(virtualRow.start))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["list__item", {
              'list__item_all-products': _ctx.preparedVisibleItems[virtualRow.index].id === -1,
              list__item_selectable: !_ctx.isCheckDisabled(_ctx.preparedVisibleItems[virtualRow.index]),
              list__item_selected: _ctx.getSelectionSetter.has(_ctx.preparedVisibleItems[virtualRow.index].id),
            }]),
                    style: _normalizeStyle(_ctx.getListItemStyle(_ctx.preparedVisibleItems[virtualRow.index])),
                    onClick: ($event: any) => (_ctx.checkClick(_ctx.preparedVisibleItems[virtualRow.index]))
                  }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["list__item-arrow", {
                'list__item-arrow_open': _ctx.preparedVisibleItems[virtualRow.index].isOpen,
                'list__item-arrow_hidden': !_ctx.preparedVisibleItems[virtualRow.index].isFolder,
              }]),
                      onClick: _withModifiers(($event: any) => (_ctx.handleArrowClick(virtualRow.index)), ["stop"])
                    }, null, 10, _hoisted_12),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.getSelectionSetter.has(_ctx.preparedVisibleItems[virtualRow.index].id),
                          disabled: _ctx.isCheckDisabled(_ctx.preparedVisibleItems[virtualRow.index]),
                          value: _ctx.preparedVisibleItems[virtualRow.index].id,
                          id: String(_ctx.preparedVisibleItems[virtualRow.index].id),
                          onClick: ($event: any) => (_ctx.checkClick(_ctx.preparedVisibleItems[virtualRow.index]))
                        }, null, 8, _hoisted_15),
                        _createElementVNode("label", {
                          for: String(_ctx.preparedVisibleItems[virtualRow.index].id),
                          class: "form-label"
                        }, [
                          _createElementVNode("span", _hoisted_17, "Выбрать " + _toDisplayString(_ctx.preparedVisibleItems[virtualRow.index].name), 1)
                        ], 8, _hoisted_16)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "list__item-code",
                      innerHTML: _ctx.getPreparedCode(virtualRow.index)
                    }, null, 8, _hoisted_18),
                    (_ctx.preparedVisibleItems[virtualRow.index].isFolder)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["list__item-name", { 'list__item-name_medium': _ctx.preparedVisibleItems[virtualRow.index].id === -1 }]),
                      innerHTML: _ctx.preparedVisibleItems[virtualRow.index].name
                    }, null, 10, _hoisted_20),
                    (_ctx.preparedVisibleItems[virtualRow.index].isFolder && _ctx.multiple)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "list__item-events",
                          onClick: _withModifiers(($event: any) => (_ctx.openLocalContextMenu($event, _ctx.preparedVisibleItems[virtualRow.index])), ["stop"])
                        }, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "17",
                            height: "16",
                            viewBox: "0 0 17 16",
                            fill: "none"
                          }, [
                            _createElementVNode("circle", {
                              cx: "8.5",
                              cy: "8",
                              r: "1",
                              fill: "#231F20"
                            }),
                            _createElementVNode("circle", {
                              cx: "4.5",
                              cy: "8",
                              r: "1",
                              fill: "#231F20"
                            }),
                            _createElementVNode("circle", {
                              cx: "12.5",
                              cy: "8",
                              r: "1",
                              fill: "#231F20"
                            })
                          ], -1)
                        ]))], 8, _hoisted_21))
                      : _createCommentVNode("", true)
                  ], 14, _hoisted_11)
                ], 12, _hoisted_10))
              }), 128))
            ], 4))
          : _createCommentVNode("", true),
        (!_ctx.visibleItems.length && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "text-center" }, "Нет данных.", -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_ButtonComponent, {
          mod: "gradient-bg",
          onClick: _ctx.select
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("Выбрать", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_ButtonComponent, {
          mod: "transparent-bg",
          onClick: _ctx.closeCatalog
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("Отменить", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      (_ctx.multiple)
        ? (_openBlock(), _createBlock(_component_LocalContextMenu, {
            key: 0,
            isVisible: _ctx.localContextMenu.isVisible,
            position: _ctx.localContextMenu.position,
            onAction: _ctx.handleLocalContextMenuAction,
            onClose: _ctx.closeLocalContextMenu
          }, null, 8, ["isVisible", "position", "onAction", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}